<template>
  <v-dialog v-model="dialog" max-width="700px" content-class="dialog-border-radius">
    <v-card class="border">
      <v-card-title style="display: contents">
        <v-card class="card-header" style="box-shadow: none;">
          <span class="text-h5">Дополнительные адреса</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="close"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
      </v-card-title>
      <v-card-text>
        <v-list>
          <div v-if="['admin', 'admin-engineer'].includes(this.roleName) && dataAddresses.length < 3 && isAddingAddress">
            <h4>Добавить дополнительный адрес. Максимум 3 адреса</h4>
            <v-row align="center">
              <v-col cols="9" class="pt-6">
                <v-combobox
                  v-model="address"
                  @keyup="startTypingTimer"
                  :items="addresses"
                  item-text="addresses"
                  prepend-inner-icon="mdi-rename-box-outline"
                  :search-input.sync="searchAddress"
                  return-object
                  flat
                  label="Дополнительный адрес"
                  outlined
                  dense
                ></v-combobox>
              </v-col>
              <v-col cols="3" class="d-flex justify-end pt-0">
                <v-btn color="primary" @click="addAddress" :disabled="!address">
                  <v-icon>mdi-plus-circle</v-icon>
                  <span v-if="!isCheckSizeSmall" class="ml-2">Добавить</span>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-list dense class="mt-4 pt-0">
            <h4 align="center" v-if="dataAddresses.length === 3">
              Можно добавить не более 3 дополнительных адресов.
            </h4>
            <h4 align="center" v-if="!isAddingAddress">
              По этим адресам также обслуживается наш шлагбаум.
              Вы можете предложить клиентам приобрести брелки для удобного и быстрого доступа.
            </h4>
            <template v-if="dataAddresses.length">
              <v-list-item
                v-for="(address, index) in dataAddresses"
                :key="index"
                class="address-item"
              >
                <v-list-item-content>
                  <v-list-item-title class="address-text">
                    {{ address.address }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="date-text">
                    {{ ruDateFormat(address.created_at) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-btn
                  icon
                  color="red"
                  @click="removeAddress(address.id)"
                  :disabled="(roleName !== 'admin' && roleName !== 'admin-engineer') || !isAddingAddress"
                  class="delete-btn"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item>
            </template>
            <template v-else>
              <v-list-item>
                <v-list-item-content class="text-center">
                  <v-list-item-title class="empty-message">
                    Дополнительных адресов на этот шлагбаум нет
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [ruDateFormatMixin],
  props: {
    dataAddresses: {
      type: Array,
      required: true,
    },
    isCheckSizeSmall: {
      type: Boolean,
    },
    isAddingAddress: {
      type: Boolean,
    },
  },
  data () {
    return {
      dialog: false,
      address: '',
      typingTimer: null,
      searchAddress: '',
    };
  },
  computed: {
    ...mapGetters({
      addresses: 'Doorphone/addresses',
      roleName: 'roleName',
    }),
  },
  methods: {
    ...mapActions({
      getAddressSearch: 'Doorphone/getAddressSearch',
    }),
    startTypingTimer (val) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (!this.isFirstLoading && val.srcElement._value) {
          this.getAddressSearch({
            value: val.srcElement._value,
          })
            .then((res) => {
              this.region = null;
            });
        }
      }, 600);
    },
    addAddress () {
      if (!this.address.trim()) return;
      this.$emit('add-address', this.address);

      this.close();
    },
    removeAddress (item) {
      this.$emit('remove-address', item);

      this.close();
    },
    open () {
      this.dialog = true;
    },
    close () {
      this.dialog = false;
      this.address = '';
    },
  },
};
</script>
<style lang="scss" scoped>
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.border {
  border-radius: 16px;
}

.v-application p {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
}
.hist-but {
  cursor: pointer;
  color: cornflowerblue;
  font-weight: 400 !important;
  font-size: 15px !important;
  margin-bottom: 0 !important;
}
.btn-download-sip {
  position: absolute;
  right: 22%;
  height: 60%;
}
.address-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.address-text {
  font-size: 21px;
  font-weight: bold;
  color: #333;
}

.date-text {
  font-size: 18px;
  color: #757575;
}

.delete-btn {
  transition: transform 0.2s ease-in-out;
}

.delete-btn:hover {
  transform: scale(1.1);
}

.empty-message {
  font-size: 16px;
  font-weight: bold;
  color: #9e9e9e;
}
@media screen and (max-width: 800px) {
  .v-application p {
    font-size: 15px;
    padding-top: 5px;
  }
  .btn-download-sip {
    right: 11%;
  }
}
@media screen and (max-width: 800px) {
  .hist-but {}
}
</style>
